import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import copy from 'copy-to-clipboard';
import styles from './index.css';
import getQrCode from '../base/getQrCode';
import CommentsAndZan from './commentsAndZan/';

class ShareActionBox extends PureComponent {
    static propTypes = {
        currentPlaySource: PropTypes.object,
        config: PropTypes.object.isRequired,
        narrowWindow: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        // sina 新浪微博，wechat 微信，qqzone QQ空间，cof 朋友圈，qq QQ
        this.defaultShareItems = ['sina', 'qq', 'qqzone', 'wechat'];

        this.mapShareItemsInfo = {
            sina: { title: '分享到新浪微博', name: '新浪微博' },
            qq: { title: '分享到QQ', name: 'QQ' },
            qqzone: { title: '分享到QQ空间', name: 'QQ空间' },
            wechat: { title: '分享到微信', name: '微信' },
            cof: { title: '分享到朋友圈', name: '朋友圈' },
        };

        this.state = {
            qrImg: '',
            hasCopy: false,
            copyText: '复制',
        };
    }

    handleClick = e => {
        const item = e.currentTarget.attributes['data-item'].value;
        const {
            currentPlaySource: { title, videoLargePoster },
        } = this.props;

        if (item === 'sina') {
            window.open(
                `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
                    window.location.href,
                )}&title=${encodeURIComponent(title)}&summery=${encodeURIComponent(title)}&pic=${encodeURIComponent(
                    videoLargePoster,
                )}`,
            );
        } else if (item === 'qqzone') {
            window.open(
                `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
                    window.location.href,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(videoLargePoster)}`,
            );
        } else if (item === 'qq') {
            window.open(
                `http://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
                    window.location.href,
                )}&title=${encodeURIComponent(title)}&pics=${encodeURIComponent(videoLargePoster)}`,
            );
        }
    };

    handleCopyUrl = e => {
        copy(window.location.href);
        e.target.value = '已复制';
        this.setState({
            hasCopy: true,
            copyText: '已复制',
        });
    };

    renderShareList() {
        const {
            config: { shareItems },
        } = this.props;
        const { qrImg, hasCopy, copyText } = this.state;
        const canUseItems = [];

        if (Object.prototype.toString.call(shareItems) === '[object Array]' && shareItems.length > 0) {
            shareItems.forEach(item => {
                if (this.defaultShareItems.indexOf(item) >= 0) {
                    canUseItems.push(item);
                }
            });
        }

        return canUseItems.map((item, index) => (
            <li key={index} className={styles[`item_${item}`]}>
                <a
                    data-item={item}
                    className={styles[item]}
                    href="javascript:void(0)"
                    title={this.mapShareItemsInfo[item].title}
                    onClick={this.handleClick}>
                    {item === 'wechat' ? (
                        <Fragment>
                            <span>{this.mapShareItemsInfo[item].name}</span>
                            <span className={styles.vShareMore}>展开</span>
                        </Fragment>
                    ) : (
                        this.mapShareItemsInfo[item].name
                    )}
                </a>
                {item === 'wechat' ? (
                    <div className={styles.vShareMoreShow}>
                        <div className={styles.vShareOther}>
                            <ul className={styles.vShareLike}>
                                <li className={styles.sinalike}>
                                    <iframe
                                        width="62"
                                        height="22"
                                        frameBorder="0"
                                        marginWidth="0"
                                        marginHeight="0"
                                        scrolling="no"
                                        border="0"
                                        src="http://widget.weibo.com/relationship/followbutton.php?width=136&amp;height=22&amp;uid=1806128454&amp;style=1&amp;btn=red&amp;dpc=1"
                                    />
                                </li>
                            </ul>
                            <ul className={styles.vShareUrl}>
                                <li className={styles.vShareEipt}>
                                    <label>播放地址</label>
                                    <input
                                        type="text"
                                        value={window.location.href}
                                        id="vShareUrl"
                                        className={styles.ipttxt}
                                        readOnly
                                    />
                                    <input
                                        type="button"
                                        value={copyText}
                                        className={`${styles.iptbtn} ${hasCopy ? styles.hasCopy : ''}`}
                                        onClick={this.handleCopyUrl}
                                    />
                                </li>
                                <li className={styles.sharep} id="js_sharep">
                                    将视频分享给站外好友，或嵌入到博客、论坛
                                </li>
                            </ul>
                        </div>
                        <div className={styles.vShareQr}>
                            <p>
                                扫一扫<br />分享更方便
                            </p>
                            <img className={styles.js_share2CodeImg} src={qrImg} />
                        </div>
                    </div>
                ) : null}
            </li>
        ));
    }

    async componentDidMount() {
        const shareQrCode = await getQrCode(window.location.href);

        if (shareQrCode && shareQrCode.qrcode_url) {
            this.setState({
                qrImg: shareQrCode.qrcode_url,
            });
        }
    }

    render() {
        const {
            config: { width = 930, clickComments = () => {} },
            currentPlaySource: { vid, commentUrl },
            narrowWindow,
        } = this.props;

        return (
            <div className={`${styles.shareActionBox} ${narrowWindow ? styles.narrow : ''}`} style={{ width }}>
                <div className={styles.vShare}>
                    <ul className={styles.shareList}>{this.renderShareList()}</ul>
                </div>
                <div className={styles.vDown}>
                    <div className={styles.vDownSimple}>
                        <span className={styles.vDownView}>下载客户端</span>
                    </div>
                    <div className={styles.vDownShow}>
                        <div className={styles.vDownShowInner}>
                            <div className={styles.vDownImg}>
                                <a href="https://a.ifeng.com/?from=pcVideo" target="_blank">
                                    <img
                                        className={styles.js_phoneWatchImg}
                                        src="//x0.ifengimg.com/ucms/qr/2021_09/870CE559BCBD54DB36A25BFBFF6A8155BD3FAD3D_size1_w260_h260.png"
                                        width="110"
                                        height="110"
                                    />
                                </a>
                            </div>
                            <p>
                                下载客户端<br />独家抢先看
                            </p>
                        </div>
                    </div>
                </div>
                <CommentsAndZan vid={vid} commentUrl={commentUrl} clickComments={clickComments} />
            </div>
        );
    }
}

export default ShareActionBox;
